import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from '../locales/en';
import no from '../locales/no';

export const defaultNS = 'translation';

export const resources = {
  en,
  no,
};

/* DEV-NOTE:
 * MK (ref. Henni) ønsker ikke browser language detection. De ønsker at default-språk er norsk
 */
// this is crucial to get the browser language right
// const detection = {
//   order: ['querystring', 'navigator'],
//   lookupQuerystring: 'lng',
// };
// i18next.use(LanguageDetector).init({ detection, resources, defaultNS, fallbackLng: 'no', debug: false });
i18next.use(LanguageDetector).init({ resources, defaultNS, lng: 'no', fallbackLng: 'no', debug: false });

export default i18next;
